import { createAction } from "redux-api-middleware";

const BASE_URL = process.env.REACT_APP_PG3_APP_DOMAIN;

export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILURE = "AUTH_FAILURE";
export const FORGOT_EMAIL_SENT_SUCCESS = "FORGOT_EMAIL_SENT_SUCCESS";
export const REFRESH_TOKEN_REQUEST = "REFRESH_TOKEN_REQUEST";
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_FAILURE = "REFRESH_TOKEN_FAILURE";

export const AGREED_TERMS_REQUEST = "AGREED_TERMS_REQUEST";
export const AGREED_TERMS_SUCCESS = "AGREED_TERMS_SUCCESS";
export const AGREED_TERMS_FAILURE = "AGREED_TERMS_FAILURE";
export const ADD_PRACTITIONER_REQUEST = "ADD_PRACTITIONER_REQUEST";
export const ADD_PRACTITIONER_SUCCESS = "ADD_PRACTITIONER_SUCCESS";
export const ADD_PRACTITIONER_FAILURE = "ADD_PRACTITIONER_FAILURE";
export const TOGGLE_DOB_BANNER_STATE = "TOGGLE_DOB_BANNER_STATE";

export const REG_PAN_REQUEST = "REG_PAN_REQUEST";
export const REG_PAN_SUCCESS = "REG_PAN_SUCCESS";
export const REG_PAN_FAILURE = "REG_PAN_FAILURE";

export const LOGOUT_ST = "LOGOUT_ST";
export const LOGOUT = "LOGOUT_ST";
export const LOGOUT_SS = "LOGOUT_SS";
export const LOGOUT_FR = "LOGOUT_FR";
export const CHANGE_IS_AUTH = "CHANGE_IS_AUTH";

export const TRIGGER_SSO_REQUEST = "TRIGGER_SSO_REQUEST";
export const TRIGGER_SSO_SUCCESS = "TRIGGER_SSO_SUCCESS";
export const TRIGGER_SSO_FAILURE = "TRIGGER_SSO_FAILURE";
export const EXCHANGE_TOKEN_REQUEST = "EXCHANGE_TOKEN_REQUEST";
export const EXCHANGE_TOKEN_SUCCESS = "EXCHANGE_TOKEN_SUCCESS";
export const EXCHANGE_TOKEN_FAILURE = "EXCHANGE_TOKEN_FAILURE";

export const authenticate = (userEmail, password, auth_code, ssoCode) => {
  let params = {
    user: {
      email: userEmail.trim(),
      password: password,
    },
    auth_code: auth_code,
    sso_code: ssoCode
  };
  return createAction({
    endpoint: BASE_URL + `/login/`,
    method: "POST",
    body: JSON.stringify(params),
    headers: { "Content-Type": "application/json"},
    types: [
      AUTH_REQUEST,
      {
        type: AUTH_SUCCESS,
        payload: (action, state, res) => {
          const authToken = res.headers.get("Authorization");
          return res.json().then((json) => {
            return { ...json, token: authToken };
          });
        },
      },
      AUTH_FAILURE,
    ],
  });
};

export const changeIsAuth = (payload) => ({
  type: CHANGE_IS_AUTH,
  payload,
});

export const __logout = (token, currentPractice, currentPracticeID) => {
  const protocol = process.env.REACT_APP_PROTOCOL;
  const PG3_BASE_URL = process.env.REACT_APP_PG3_APP_BASE_DOMAIN;
  return createAction({
    endpoint: `${protocol}//${currentPractice}${PG3_BASE_URL}/logout`,
    // endpoint: BASE_URL + `/logout`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
      "Current-Practice": currentPracticeID,
    },
    types: [LOGOUT_ST, LOGOUT_SS, LOGOUT_FR],
  });
};

export const refreshToken = (token, currentPractice, currentPracticeID) => {
  const protocol = process.env.REACT_APP_PROTOCOL;
  const PG3_BASE_URL = process.env.REACT_APP_PG3_APP_BASE_DOMAIN;
  return createAction({
    endpoint: `${protocol}//${currentPractice}${PG3_BASE_URL}/refresh_token`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
      "Current-Practice": currentPracticeID,
    },
    types: [
      REFRESH_TOKEN_REQUEST,
      {
        type: REFRESH_TOKEN_SUCCESS,
        payload: (action, state, res) => {
          const authToken = res.headers.get("Authorization");
          return res.json().then((json) => {
            return { ...json, token: authToken };
          });
        },
      },
      REFRESH_TOKEN_FAILURE,
    ],
  });
};

export const verifyOtp = (id, userType, otp) => {
  let params = {
    otp,
  };
  return createAction({
    endpoint: BASE_URL + `/${id}/${userType}/verify_otp/`,
    method: "POST",
    body: JSON.stringify(params),
    headers: { "Content-Type": "application/json" },
    types: [AUTH_REQUEST, FORGOT_EMAIL_SENT_SUCCESS, AUTH_FAILURE],
  });
};

export const addPractitioner = (data) => {
  const protocol = process.env.REACT_APP_PROTOCOL;
  const baseUrl = process.env.REACT_APP_PG3_APP_DOMAIN;
  return createAction({
    endpoint: `${baseUrl}/create_account`,
    body: JSON.stringify(data),
    method: "POST",
    headers: { "Content-Type": "application/json" },
    types: [
      ADD_PRACTITIONER_REQUEST,
      ADD_PRACTITIONER_SUCCESS,
      ADD_PRACTITIONER_FAILURE,
    ],
  });
};

export const registerPureAccountCall = (data) => {
  const protocol = process.env.REACT_APP_PROTOCOL;
  const baseUrl = process.env.REACT_APP_PG3_APP_DOMAIN; 
  return createAction({
    endpoint: `${baseUrl}/fetch_pure_account_details`,
    body: JSON.stringify(data),
    method: "POST",
    headers: { "Content-Type": "application/json" },
    types: [REG_PAN_REQUEST, REG_PAN_SUCCESS, REG_PAN_FAILURE],
  });
};

export const resendOtp = (id, userType) => {
  return createAction({
    endpoint: BASE_URL + `/${id}/${userType}/resend_otp/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    types: [AUTH_REQUEST, FORGOT_EMAIL_SENT_SUCCESS, AUTH_FAILURE],
  });
};

export const sendOTPForMultiDomain = (id, practiceID) => {
  return createAction({
    endpoint: BASE_URL + `/${practiceID}/multi_domain/${id}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    types: [AUTH_REQUEST, FORGOT_EMAIL_SENT_SUCCESS, AUTH_FAILURE],
  });
};

export const forgotPassword = (email) => {
  let params = {
    email,
  };
  return createAction({
    endpoint: BASE_URL + `/password/`,
    method: "POST",
    body: JSON.stringify(params),
    headers: { "Content-Type": "application/json" },
    types: [AUTH_REQUEST, FORGOT_EMAIL_SENT_SUCCESS, AUTH_FAILURE],
  });
};

export const acceptTermsConditions = (
  token,
  currentPracticeID,
  currentPractice,
  type
) => {
  const protocol = process.env.REACT_APP_PROTOCOL;
  const PG3_BASE_URL = process.env.REACT_APP_PG3_APP_BASE_DOMAIN;
  return createAction({
    endpoint: `${protocol}//${currentPractice}${PG3_BASE_URL}/practice/terms_and_condition/${type}/${currentPracticeID}`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
      "Current-Practice": currentPracticeID,
    },
    types: [AGREED_TERMS_REQUEST, AGREED_TERMS_SUCCESS, AGREED_TERMS_FAILURE],
  });
};

// export const sendResetPassword=()=>{

export const contactUsForm = (data) => {
  return createAction({
    endpoint: BASE_URL + `/contact_us`,
    method: "POST",
    body: JSON.stringify(data),
    headers: { "Content-Type": "application/json" },
    types: [
      ADD_PRACTITIONER_REQUEST,
      ADD_PRACTITIONER_SUCCESS,
      ADD_PRACTITIONER_FAILURE,
    ],
  });
};

export const postLogin = (token, currentPracticeID) => {
  return createAction({
    endpoint: BASE_URL + `/practice/post_login/${currentPracticeID}`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Current-Practice": currentPracticeID,
    },
    types: [
      ADD_PRACTITIONER_REQUEST,
      ADD_PRACTITIONER_SUCCESS,
      ADD_PRACTITIONER_FAILURE,
    ],
  });
};

export const updatePassword = ({ data }) => {
  return createAction({
    endpoint: BASE_URL + `/update_expired_password`,
    method: "POST",
    body: JSON.stringify(data),
    headers: { "Content-Type": "application/json" },
    types: [
      ADD_PRACTITIONER_REQUEST,
      ADD_PRACTITIONER_SUCCESS,
      ADD_PRACTITIONER_FAILURE,
    ],
  });
};

export const triggerSSO = (country) => {
  // Read SSO configuration from environment with safe defaults.
  const tenantId = process.env.REACT_APP_SSO_TENANT_ID || "59d6de52-9304-4f7f-8381-10448bdc6e61";
  const clientId = process.env.REACT_APP_SSO_CLIENT_ID || "45ce4542-8ccc-46a0-8c03-68dec0c3b5d5";
  const scope = process.env.REACT_APP_SSO_SCOPE || "email openid profile";

  // Determine redirect URI based on country if provided. Support env-specific overrides like
  // REACT_APP_SSO_REDIRECT_URI_US, REACT_APP_SSO_REDIRECT_URI_CA, etc.
  let redirectUri = process.env.REACT_APP_SSO_REDIRECT_URI_US || "https://bab4e42982f6.ngrok-free.app/users/login";
  try {
    if (country) {
      const key = `REACT_APP_SSO_REDIRECT_URI_${country.toString().toUpperCase()}`;
      if (process.env[key]) {
        redirectUri = process.env[key];
      }
    }
  } catch (e) {
    // ignore and use default
  }

  const baseAuthorize = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize`;
  const ssoUrl = new URL(baseAuthorize);

  const params = {
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
    response_mode: "query",
    scope: scope,
  };

  ssoUrl.search = new URLSearchParams(params).toString();

  if (!process.env.REACT_APP_SSO_CLIENT_ID || !process.env.REACT_APP_SSO_REDIRECT_URI) {
    console.warn("SSO config missing env vars: REACT_APP_SSO_CLIENT_ID or REACT_APP_SSO_REDIRECT_URI. Using defaults.");
  }

  // Redirect user to Microsoft login
  console.log("Redirecting to SSO URL:", ssoUrl.toString());
  window.location.href = ssoUrl.toString();

  // Return action for state management
  return {
    type: [TRIGGER_SSO_REQUEST, TRIGGER_SSO_SUCCESS, TRIGGER_SSO_FAILURE],
  };
};

